@if (fieldPreview(); as fieldPreview) {
  <div class="flex h-full w-full items-center justify-center gap-1.5">
    @if (fieldPreview.error) {
      <IBadge
        icon="alertTriangle"
        color="orange"
        variant="soft"
        size="sm"
        [iTooltip]="fieldPreview.error"
        iTooltipPlacement="top-center"
      />
    }
    @if (showDiff()) {
      <span class="text-sm">
        @if (diff().added.length > 0) {
          <span class="text-green-600">+{{ diff().added.length }}</span>
        }
        @if (diff().removed.length > 0) {
          <span class="ml-1 text-red-600">-{{ diff().removed.length }}</span>
        }
      </span>
    } @else if (fieldPreview.isCreation) {
      <span class="text-sm text-green-600"> +{{ diff().total }} </span>
    } @else {
      @let isFieldUnchanged = !fieldPreview.hasChanged;
      <span class="text-sm" [class.text-gray-400]="isFieldUnchanged" [class.text-gray-700]="!isFieldUnchanged">
        {{ diff().total }} ASINs
      </span>
    }
  </div>
} @else if (isResultMode()) {
  <div class="flex h-full w-full items-center justify-center">
    <span class="text-sm text-gray-700">{{ resultCount() }} ASINs</span>
  </div>
}
